module.exports = __webpack_public_path__ + "static/media/icon_split_disabled.fb5077e7.svg";